import { RadioButton } from "../components/RadioButton";
import { RadioGroup } from "../components/RadioGroup";
import { useDispatch, useSelector } from "react-redux";
import { createReturnParameterSelector, setReturnParameter } from "../store";

// todo: maybe think about another name
export const Enum2Columns = ({parameterHandler}) => {
    const parameterValue = useSelector(parameterHandler.selector);
    const enumOptions = parameterHandler.description.options;
    const dispatch = useDispatch();
    return (
        <div className="gruf-enum-2-columns">
            <RadioGroup>{enumOptions.map((option, index) => {
                return (
                    <RadioButton 
                        key={index} 
                        checked={parameterValue == option} 
                        onNewValue={(value) => value && dispatch(parameterHandler.updater(option))}
                    >
                        {option}
                    </RadioButton>
                )
            })}</RadioGroup>
        </div>
    )
}